"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Card = _interopRequireDefault(require("../../Card/Card"));
var _Modal = _interopRequireDefault(require("../../Modal"));
var _Button = _interopRequireDefault(require("../../Button/Button"));
var _Svg = _interopRequireDefault(require("../../Svg/Svg"));
var _CardSlider = _interopRequireDefault(require("../../CardSlider/CardSlider"));
var _Toggle = _interopRequireDefault(require("../../helpers/Toggle"));
var _constants = require("../../constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var MapCard = function MapCard(_ref) {
  var selectedDay = _ref.selectedDay,
    days = _ref.days,
    selectedIndex = _ref.selectedIndex,
    updateActiveDay = _ref.updateActiveDay;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "map-card"
  }, /*#__PURE__*/_react["default"].createElement(_Card["default"], {
    heading: selectedDay.title && selectedDay.title.rendered,
    subheading: selectedDay.intro
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "margin-bottom-md"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: (0, _classnames["default"])('text-xs', 'd8-u-text-uppercase', 'd8-u-ls-sm', 'd8-u-text-bold', 'd8-u-color-contrast-high', 'margin-bottom-md')
  }, "Day by day"), days.map(function (d, i) {
    return /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      key: JSON.stringify(d),
      buttonType: selectedIndex === i ? _constants.BUTTON_TYPES.CIRCLE_ICON_PRIMARY : _constants.BUTTON_TYPES.CIRCLE_ICON_GHOST,
      className: "map-button margin-right-sm",
      text: i + 1,
      onClick: function onClick() {
        return updateActiveDay(i);
      }
    });
  })), /*#__PURE__*/_react["default"].createElement("div", null, selectedDay.title && selectedDay.title.rendered && /*#__PURE__*/_react["default"].createElement("h3", {
    className: (0, _classnames["default"])('card--basic__heading', 'd8-u-ls-sm', 'text-xl', 'margin-bottom-xxs')
  }, "Day ", selectedIndex + 1, ": ", selectedDay.title && selectedDay.title.rendered), selectedDay.intro && /*#__PURE__*/_react["default"].createElement("p", {
    className: (0, _classnames["default"])('text-sm', 'd8-u-color-contrast-high', 'd8-u-text-bold', 'margin-bottom-xxs')
  }, selectedDay.intro), selectedDay.acf.location && /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center margin-top-xs"
  }, /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
    className: "icon--sm margin-right-xs",
    name: "location-bold",
    fill: _constants.COLORS.PRIMARY
  }), /*#__PURE__*/_react["default"].createElement("p", {
    className: (0, _classnames["default"])('text-sm', 'd8-u-color-primary', 'd8-u-text-bold', 'd8-u-ls-sm')
  }, selectedDay.acf.location))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "margin-top-md"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "map-card__content",
    dangerouslySetInnerHTML: {
      __html: selectedDay.content && selectedDay.content.rendered
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "margin-top-md"
  }, selectedDay.acf.highlights ? /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_CardSlider["default"], {
    type: _constants.CARD_SLIDER_TYPES.NON_FULL_WIDTH,
    parentOffset: 16
  }, selectedDay.acf.highlights.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_Toggle["default"], {
      key: JSON.stringify(item)
    }, function (_ref2) {
      var toggle = _ref2.toggle,
        on = _ref2.on;
      return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_Card["default"], {
        template: "ImageCard",
        imageCardTemplate: "Basic",
        size: "xxs",
        bgImage: {
          url: item.featured_image_src || item.acf._thumbnail_id && item.acf._thumbnail_id.url,
          alt: item.post_title
        },
        onClick: toggle
      }), /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
        style: {
          width: 'var(--max-width-xxs)',
          minWidth: 'unset'
        },
        template: "MediaModal",
        on: on,
        toggle: toggle,
        title: item.post_title.replace(/<[^>]*>/g, ''),
        text: item.post_content.replace(/<[^>]*>/g, ''),
        image: {
          url: item.featured_image_src || item.acf._thumbnail_id && item.acf._thumbnail_id.url,
          alt: item.post_title
        },
        video: item.acf && item.acf.video
      }));
    });
  }))) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "aspect-16-9 margin-top-md"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: "d8-u-radius-md",
    src: selectedDay.featured_image_src,
    alt: selectedDay.title && selectedDay.title.rendered
  }))))));
};
MapCard.propTypes = {
  days: _propTypes["default"].array,
  selectedDay: _propTypes["default"].object,
  selectedIndex: _propTypes["default"].number,
  updateActiveDay: _propTypes["default"].func
};
var _default = exports["default"] = MapCard;